const HEADER_HEIGHT = 63;

export default ({ breakpoints, palette, spacing, zIndex }) => ({
  root: {
    position: 'relative',
    width: '100%',
    zIndex: zIndex.appBar,
  },
  headerPlaceholder: {
    visibility: 'none',
  },
  header: {
    display: 'block',
    backgroundColor: palette.background.primary,
    borderBottom: `1px solid ${palette.layout.line.divider}`,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    minHeight: HEADER_HEIGHT,
    [breakpoints.down('md')]: {
      minHeight: 55,
    },
  },
  navWrapper: {
    [breakpoints.up('md')]: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
    },
    '.jobSurvey &': {
      display: 'none',
    },
  },
  linksWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  button: {
    marginLeft: 'auto',
  },
  [breakpoints.down('md')]: {
    headerEmptySpace: {
      flexGrow: 1,
    },
  },
  navSearch: {
    marginLeft: 'auto',
  },
  actions: {
    display: 'flex',
    marginLeft: spacing(2),

    [breakpoints.down('md')]: {
      display: 'none',
    },
  },
  action: {
    '&:not(:last-child)': {
      marginRight: spacing(2),
    },
  },
  innerWrapper: {
    margin: spacing(0, 2),
  },
  contentWrapper: {
    position: 'static',
  },
  divider: {
    [breakpoints.down('lg')]: {
      display: 'none',
    },
  },
});
